<template>
  <div class="card6">
    <div class="bgBox" @click.stop="goDetail">
      <div class="imgList" v-for="(item, index) in imgList" :key="index">
        <div style="width: 100%; display: flex;" v-for="(item1, index1) in item" :key="index1">
          <div class="imgItem" :style="{backgroundImage: 'url(' + item1[0].url + ')'}"></div>
        </div>
      </div>
    </div>
    <div class="cardInfo">
      <div class="title two_line" @click.stop="goDetail">
        <span style="color: #008BFF;" v-if="item.zhuanti">专题 | </span>
        <span>{{ item.title }}</span>
      </div>
      <div class="otherInfo flex_center">
        <div class="sourceInfo flex_row flex_center">
          <div class="logo_box" v-if="userInfo.logo !== ''">
            <img class="sourceImg" :src="userInfo.logo" alt="">
            <img class="v_icon" :src="item.xinhua.vimgUrl" alt="" v-if="item.xinhua && item.xinhua.vflag">
          </div>
          <div class="sourceName">{{ userInfo.name }}</div>
          <div class="sourceName" v-if="item.commentNum">{{ item.commentNum }}评</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ArrayGroup } from '@/utils'

export default {
  name: 'card6',
  props: [ 'item' ],
  computed: {
    imgList () {
      let list = this.item.coverImageList
      return ArrayGroup( list, 3 )
    },
    // 用户信息
    userInfo () {
      let item = this.item
      let userInfo = {
        logo: '',
        name: item.sourceName || ''
      }
      if ( item.cuser ) {
        userInfo.logo = item.cuser.logo
        userInfo.name = item.cuser.name
        userInfo.uuid = item.cuser.cuserThirdId
      }
      if ( item.xinhua ) {
        userInfo.logo = item.xinhua.xinhuaCover
        userInfo.name = item.xinhua.xinHuaName
        userInfo.uuid = item.xinhua.xinHuaUuid
      }
      return userInfo
    }
  },
  methods: {
    // 打开详情
    goDetail () {
      this.$emit( 'pauseMedia' )
      window.goDetail( this.item )
    }
  }
}
</script>

<style scoped>
.card6 {
  width: 100%;
  height: 224px;
  background-image: url("../../../assets/images1/recommend/showType3_bg.png");
  background-size: cover;
  padding: 5px;
  box-sizing: border-box;
  position: relative;
  margin-bottom: 12px;
  border-radius: 12px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 6%);
}

.bgBox {
  margin-bottom: 12px;
}

.imgList {
  display: flex;
  margin-bottom: 4px;
}

.imgItem {
  flex: 1;
  height: 63px;
  margin-right: 4px;
  border-radius: 12px;
  background-size: cover;
  background-position: 50%;
}

.imgList > .imgItem:nth-child(1) {
  border-radius: 0 2px 2px 0;
}

.imgList > .imgItem:nth-child(2) {
  border-radius: 2px;
}

.imgList > .imgItem:nth-child(3) {
  border-radius: 2px 0 0 2px;
}

.bgBox > .imgList:last-child {
  margin-bottom: 0;
}
</style>

<style scoped>
.cardInfo {
  width: 100%;
  justify-content: space-between;
  padding-bottom: 20px;
  box-sizing: border-box;
}

.title {
  padding: 0 8px 0 6px;
  box-sizing: border-box;
  font-size: 16px;
  line-height: 20px;
  color: #fff;
  margin-bottom: 8px;
}

.otherInfo {
  padding: 0 8px 0 6px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}

.sourceInfo {
  font-size: 12px;
  line-height: 17px;
  color: rgba(255, 255, 255, .65);
}

.sourceImg {
  width: 18px;
  height: 18px;
  display: block;
  margin-right: 10px;
  border-radius: 50%;
  object-fit: cover;
}

.logo_box {
  width: 20px;
  height: 19px;
  margin-right: 10px;
  position: relative;
}

.v_icon {
  width: 8px;
  height: 8px;
  object-fit: cover;
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 1;
}

.sourceName {
  margin-right: 8px;
}
</style>